export enum DashboardCards {
  CAPACITY_CHART = "capacityChart",
  INDUSTRY_CHART = "industryChart",
  EMP_SALES_CHART = "empSalesChart",
  PLAN_VS_CAMPAIGN_CHART = "planCampaignChart",
}
